export class DadosPix {
  email: string;

  constructor() {
  }

  outroSemDadosSensitivos() {
    const outro = new DadosPix();

    outro.email = this.email;

    return outro;
  }
}
